// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"0d63d2ea","334":"2c06d76c","854":"6e5f98a9"}[chunkId] + ".chunk.css";
};